"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminListingsResponseDto = instanceOfAdminListingsResponseDto;
exports.AdminListingsResponseDtoFromJSON = AdminListingsResponseDtoFromJSON;
exports.AdminListingsResponseDtoFromJSONTyped = AdminListingsResponseDtoFromJSONTyped;
exports.AdminListingsResponseDtoToJSON = AdminListingsResponseDtoToJSON;
exports.AdminListingsResponseDtoToJSONTyped = AdminListingsResponseDtoToJSONTyped;
var AdminListingDto_1 = require("./AdminListingDto");
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
/**
 * Check if a given object implements the AdminListingsResponseDto interface.
 */
function instanceOfAdminListingsResponseDto(value) {
    if (!('listings' in value) || value['listings'] === undefined)
        return false;
    return true;
}
function AdminListingsResponseDtoFromJSON(json) {
    return AdminListingsResponseDtoFromJSONTyped(json, false);
}
function AdminListingsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listings': (json['listings'].map(AdminListingDto_1.AdminListingDtoFromJSON)),
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function AdminListingsResponseDtoToJSON(json) {
    return AdminListingsResponseDtoToJSONTyped(json, false);
}
function AdminListingsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listings': (value['listings'].map(AdminListingDto_1.AdminListingDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
